import { combineReducers, configureStore } from "@reduxjs/toolkit";
import allPostsSlice from "./Slices/allPostsSlice";
import publicSlice from "./Slices/publicSlice";
import postSlice from "./Slices/postSlice";
import getFilesSlice from "./Slices/getFilesSlice";
import deleteFileSlice from "./Slices/deleteFileSlice";
import deletePublishedFileSlice from "./Slices/deletePublishedFileSlice";
import a11ySlice from "./Slices/a11ySlice";
import fileContentSlice from "./Slices/fileContentSlice";
import listPostsSlice from "./Slices/listPostsSlice";
import favoritePostsSlice from "./Slices/favoritePostsSlice";
import patchFavoritePost  from "./Slices/patchFavoritePost";
import updatePostPosition from "./Slices/updatePostPosition";
import updatePostDescriptionSlice from "./Slices/updatePostDescriptionSlice";
import AllHistoryLogsSlice from "./Slices/getHistoryLogs";
import AllLogUsersSlice from "./Slices/allLogUsers"

const reducer = combineReducers({
  a11ySlice,
  allPostsSlice,
  favoritePostsSlice,
  listPostsSlice,
  publicSlice,
  postSlice,
  getFilesSlice,
  deleteFileSlice,
  deletePublishedFileSlice,
  fileContentSlice,
  patchFavoritePost,
  updatePostPosition,
  updatePostDescriptionSlice,
  AllHistoryLogsSlice,
  AllLogUsersSlice,
});

export const store = configureStore({ reducer });
